import { Component, Input } from '@angular/core';

@Component({
	selector: 'online-sale-presentation',
	templateUrl: "./online-sale.presentation.html"
})
export class OnlineSalePresentation {
	@Input() saleUrl: string;
	@Input() errorText: string;
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/online-sale/online-sale.presentation.ts